import "@/src/api/client";
import { normalizeApiError, type ApiErrorDetails } from "@/src/api/error-utils";
import {
  gmailConnectorAdminControllerSyncConnectorHistory,
  whatsAppDeviceConnectorAdminControllerSyncConnectorHistory,
  whatsAppDeviceConnectorAdminControllerSyncConversationHistory,
} from "@/src/api/generated/sdk.gen";
import type {
  ContactCenterConnector,
  ContactCenterHistorySyncResponse,
} from "@/src/features/contact-center/types";
import { gmailConnectorType } from "./connector-constants";

export type ContactCenterConnectorActionResult<T> = {
  data: T | null;
  error: ApiErrorDetails | null;
};

export async function syncConnectorMessageHistory(
  connector: ContactCenterConnector | string,
): Promise<
  ContactCenterConnectorActionResult<ContactCenterHistorySyncResponse>
> {
  const connectorId = typeof connector === "string" ? connector : connector.id;
  const response =
    typeof connector !== "string" && connector.settings.connectorType === gmailConnectorType
      ? await gmailConnectorAdminControllerSyncConnectorHistory({ path: { connectorId } })
      : await whatsAppDeviceConnectorAdminControllerSyncConnectorHistory({ path: { connectorId } });
  return normalizeHistorySyncResult(response);
}

export async function syncConversationMessageHistory(
  conversationId: string,
): Promise<
  ContactCenterConnectorActionResult<ContactCenterHistorySyncResponse>
> {
  return normalizeHistorySyncResult(
    await whatsAppDeviceConnectorAdminControllerSyncConversationHistory({
      path: { conversationId },
    }),
  );
}

function normalizeHistorySyncResult(response: { data?: unknown; error?: unknown }): ContactCenterConnectorActionResult<ContactCenterHistorySyncResponse> {
  if (response.data !== undefined) {
    return { data: response.data as ContactCenterHistorySyncResponse, error: null };
  }
  return {
    data: null,
    error: normalizeApiError(response.error, "Message history could not be synced."),
  };
}
